import { GB_LOCALE_CODE, US_LOCALE_CODE } from "@notemeal/locale-utils";
import { getPassioLocalizationConfig } from "./passioLocaleFromApp";
const NUTRITIONIX_BRANDED_ORG_LOCALES = new Set([US_LOCALE_CODE, GB_LOCALE_CODE]);
/** Web uses Passio branded search for non-US/GB org locales; US/GB keep Nutritionix. */
export const shouldUsePassioBrandedSearchForOrgLocale = (orgLocale) => !NUTRITIONIX_BRANDED_ORG_LOCALES.has(orgLocale);
/** Passio API headers derived from org locale only (web). */
export const getPassioLocalizationConfigForOrgLocale = (orgLocale) => getPassioLocalizationConfig(orgLocale, orgLocale, { regionLocalizationEnabled: true });
/** Branded-tab search: same locale routing but only branded typeFilters (matches Nutritionix Branded tab). */
export const getPassioLocalizationConfigForBrandedSearch = (orgLocale) => {
    const config = getPassioLocalizationConfigForOrgLocale(orgLocale);
    return {
        ...config,
        searchConfig: {
            regionFilters: config.searchConfig?.regionFilters ?? {},
            typeFilters: ["branded"],
            strictRegionMode: config.searchConfig?.strictRegionMode ?? false,
        },
    };
};
//# sourceMappingURL=passioBrandedSearchForOrgLocale.js.map